var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { __DEV__, FormControl, FormLabel, FormHelperText, } from '@companydotcom/potion';
import { Controller } from 'react-hook-form';
import { TranslationErrorMessage } from './translation-error-message';
import { RSelect } from '../potion-react-select';
export const ReactSelectField = props => {
    const { name, label, helperText, control, onChange: customOnChange, formControlStyles, errors } = props, rest = __rest(props, ["name", "label", "helperText", "control", "onChange", "formControlStyles", "errors"]);
    return (_jsx(Controller, { control: control, name: name, render: ({ field: { onChange, onBlur, value, name }, fieldState: { invalid, error } }) => {
            var _a;
            return (_jsxs(FormControl, Object.assign({ isInvalid: invalid, id: name, sx: formControlStyles }, { children: [_jsx(FormLabel, Object.assign({ htmlFor: name }, { children: label !== null && label !== void 0 ? label : '' }), void 0), _jsx(RSelect, Object.assign({ name: name, onChange: customOnChange || onChange, onBlur: onBlur, value: value }, rest), void 0), helperText && !error && _jsx(FormHelperText, { children: helperText !== null && helperText !== void 0 ? helperText : '' }, void 0), errors && (_jsx(TranslationErrorMessage, Object.assign({ errors: errors, name: name }, { children: errors && (errors === null || errors === void 0 ? void 0 : errors[name]) && ((_a = errors === null || errors === void 0 ? void 0 : errors[name]) === null || _a === void 0 ? void 0 : _a.message) }), void 0))] }), void 0));
        } }, void 0));
};
if (__DEV__) {
    ReactSelectField.displayName = 'ReactSelectField';
}
